import {
  Autocomplete,
  Box,
  CircularProgress,
  Divider,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { getDataSets } from "common-lib";
import { t } from "i18next";
import { useEffect, useState } from "react";

export default function SelectDataset({
  formData,
  updateFormData,
  selectDatasetType,
  setSelectDatasetType,
  selectedDataset,
  setSelectedDataset,
}) {
  const [datasetList, setDatasetList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const loadMoreDatasets = async (currentPage) => {
    // if (isLoading || !hasMore) return;
    if (isLoading) return;

    try {
      setIsLoading(true);
      // Autocomplete에서 검색할 때 무한 스크롤이 문제가 됨 -> 우선 300개로 제한
      const response = await getDataSets({
        page: currentPage,
        pageSize: 300,
        type: formData.type,
      });
      const newDatasets = response.data.contents;

      if (newDatasets.length === 0) {
        setHasMore(false);
        return;
      }

      // setDatasetList((prev) => [...prev, ...newDatasets]);
      setDatasetList(newDatasets);
      setPage(currentPage);
    } catch (error) {
      console.error("Failed to fetch datasets:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadMoreDatasets(1);
  }, [formData.type]);

  const handleScroll = (event) => {
    const listbox = event.target;
    if (
      listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 20 &&
      hasMore &&
      !isLoading
    ) {
      loadMoreDatasets(page + 1);
    }
  };

  const handleSelectDatasetType = (value) => {
    setSelectDatasetType(value);
  };

  const handleSelectDataset = (value) => {
    setSelectedDataset(value);
    // console.log("selectedDataset", value);
  };

  return (
    <>
      <Divider>{t("Dataset")}</Divider>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Radio
          checked={selectDatasetType === "db"}
          onChange={(e) => handleSelectDatasetType(e.target.value)}
          value="db"
          sx={{
            "& .MuiSvgIcon-root": {
              fontSize: 21,
            },
          }}
        />
        <Typography>{t("DB")}</Typography>
      </div>
      {selectDatasetType === "db" && (
        <>
          <Autocomplete
            options={datasetList}
            freeSolo
            filterSelectedOptions
            getOptionLabel={(option) => option.name}
            value={formData.dataSet}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            onChange={(event, newValue) => {
              handleSelectDataset(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={t("SelectDataset")}
                sx={{ marginTop: "3px" }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            ListboxProps={{
              onScroll: handleScroll,
              style: { maxHeight: 200 },
            }}
            loading={isLoading}
            loadingText={t("Loading")}
            noOptionsText={t("NoDatasets")}
            sx={{
              "& .MuiChip-label": {
                color: "var(--text-color)",
              },
              "& .MuiAutocomplete-tag": {
                backgroundColor: "var(--chip-color)",
              },
              "& .MuiSvgIcon-root": {
                color: "var(--svg-color)",
              },
            }}
          />
          {selectedDataset && (
            <Typography variant="body2" sx={{ pl: 1, pt: 1 }}>
              {t("Description")}: {selectedDataset?.description}
            </Typography>
          )}
        </>
      )}
      <Box>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Radio
            checked={selectDatasetType === "condition"}
            onChange={(e) => {
              handleSelectDatasetType(e.target.value);
            }}
            value="condition"
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 21,
              },
            }}
          />
          <Typography>{t("DatasetCondition")}</Typography>
        </div>
        {selectDatasetType === "condition" && (
          <Box>
            <div className="input-container">
              <input
                type="text"
                id="input-field"
                placeholder="내용을 입력하세요"
                onChange={(e) => updateFormData("image_period", e.target.value)}
                value={formData.image_period}
              />
              <label htmlFor="input-field">
                {t("ImageCollectionPeriod")} (일)
              </label>
            </div>
            <div className="input-container">
              <input
                type="text"
                id="input-field"
                placeholder="내용을 입력하세요"
                onChange={(e) =>
                  updateFormData("material_name", e.target.value)
                }
                value={formData.material_name}
              />
              <label htmlFor="input-field">{t("material")}</label>
            </div>
          </Box>
        )}
      </Box>
    </>
  );
}
